import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {Outsourced} from "../Outsourced";
import {OutsourcedSymbol} from "../reels/symbols/OutsourcedSymbol";
import {XNudgeSymbol} from "../reels/symbols/XNudgeSymbol";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";


/**
 * Created by jonas on 2022-01-12.
 */

export class DoXNudge implements SimplePresentation {

    name:string = "RevealXWays";

    constructor() {
    }

    shouldRun():boolean {
        return this.getXNudgeSymbols().length > 0;
    }

    private getXNudgeSymbols():XNudgeSymbol[] {
        return <XNudgeSymbol[]>Outsourced.reelView.getAllSymbols().filter((sym) => sym.symbolName == "XN");
    }

    start(controller:SimplePresentationRunnerController):void {
        const isQuickStop = Outsourced.apiPlugin.settings.get(APISetting.FAST_SPIN);
        const noWin = Outsourced.model.gameData.thisSpinWinnings == 0;
        const tl = gsap.timeline({
            onComplete: () => {
                controller.setSkipCallback();
                controller.finish()
            }
        })

        if (noWin) {
            tl.add(() => {})
            tl.add(() => {
                tl.progress(1);
                Outsourced.soundPlayer.playSoundBased("xNudgeDead")
            }, '>0.25')
        }

        if (isQuickStop)
            tl.add(() => {tl.timeScale(1.5)});

        tl.add(() => {controller.setSkipCallback(() => {tl.progress(1)})}, "<")
        tl.add(() => {}, '>0.65');

        this.getXNudgeSymbols().forEach((sym) => {
            const reelIndex = sym.reelID;
            const rowIndex = Outsourced.model.data.reels[reelIndex].findIndex((sym) => sym == "XN");
            const rowOrder = rowIndex == 0
                             ? [1, 2, 3]
                             : rowIndex == 1
                             ? [0, 2, 3]
                             : rowIndex == 2
                             ? [1, 3, 0]
                             : [2, 1, 0]
            tl.add(() => {
                Outsourced.reelView.moveUpZ(reelIndex, rowIndex);
            })
            tl.add(sym.expand(rowIndex));
            if (!noWin)
                tl.add(Outsourced.soundPlayer.playSoundBased("xNudgeNudge"), '<');
            tl.add(() => {
                for (let i = 0; i < 3; i++) {
                    const newSymbol = <XNudgeSymbol>Outsourced.symbolFactory.createSymbol({
                        symbolName: "XN",
                        reelID: reelIndex,
                        reelPosition: 0
                    });
                    newSymbol.hideMultiplier();
                    Outsourced.reelView.setSymbolAt(reelIndex, rowOrder[i], newSymbol);
                }
                Outsourced.reelView.moveDownZ(reelIndex, rowIndex);
            })
        })

        if (isQuickStop)
            tl.add(() => {tl.timeScale(1)});

        tl.add(() => {}, '>0.3');
    }
}
